import React from 'react';
import Advisory from '../AdvisoryCommittee/AdvisoryCommittee';
import Steering from '../SteeringCommittee/SteeringCommittee';
import Technical from '../TechnicalProgramCommittee/TechnicalProgram';
import Finance from '../FinanceCommittee/FinanceCommittee';
import Publication from '../PublicationCommittee/PublicationCommittee';
import Publicity from '../PublicityCommittee/PublicityCommittee';
import Hospitality from '../HospitalityCommittee/HospitalityCommittee';
import Accommodation from '../AccommodationCommittee/AccommodationCommittee';
import Transportation from '../TransportationCommittee/TransportationCommittee';
import StudentTeam from '../StudentTeam/StudentTeam';



const sections = [
  {
    title: "CHIEF PATRONS",
    items: [
      "Sardar Rashpal Singh Dhaliwal, Chancellor, CGC, University, Mohali",
      "Mr. Arsh Dhaliwal, Managing Director, CGC, University, Mohali"
    ]
  },
  {
    title: "PATRONS",
    items: [
      "Prof. Sushil Prashar, Executive Vice President, CGC University, Mohali",
      "Prof. Vinay Kumar Goyal, Vice Chancellor, CGC University, Mohali",      
      "Prof. Anupam Deep Sharma, Pro-Vice-Chancellor - Examination & Registrar, CGC University, Mohali"
    ]
  },
  {
    title: "GENERAL CHAIR",
    items: [
      "Prof. Abdul Quaiyam Ansari, Jamia Millia Islamia, New Delhi",
      "Prof. Arun Kumar Singh, PEC, Chandigarh, India",
      //"Prof. Pavan Shukla, SET, CGC University, Mohali",
      //"Prof. Jaspreet Kaur, SET, CGC University, Mohali",
    ]
  },
  /* {
    title: "section Oversight Committee",
    items: [
	  "Prof. Ekta Gandotra (Lead Member Coordinator for IETACS–2025 and Member-IEEE Delhi Section STDCOM on T & P Act)",
	  "Prof. Rajnish Sharma (Section Vice Chair & Member-IEEE Delhi Section STDCOM on T & P Act)",
	  "Prof. Vivek Shrivastava (Section Exec Com Member Co-opted & Member-IEEE Delhi Section STDCOM on T & P Act)",
	  "Prof. Sneha Kabra (Section Secretary & Member-IEEE Delhi Section STDCOM on T & P Act)"
	]
  },*/
 
  {
    title: "CONFERENCE CHAIR",
    items: [
      "Prof. Anish Gupta, Pro VC Academics & International Affairs, CGC University, Mohali",
    ]
  },
  {
    title: "Organising Chair/ Secretary",
    items: [
		"Prof. Sugandhi Malhotra, SET, CGC University, Mohali",
		"Prof. Navdeep Prashar, SET, CGC University, Mohali",		
    ]
  },
  {
    title: "TECHNICAL PROGRAM CHAIR",
    items: [
      "Prof. Rohit Anand, GB Pant DSEU Okhla-1 Campus, New Delhi",
      "Prof. Maitreyee Dutta, NITTTR, Chandigarh",
      "Prof. A K Verma, Thapar University, Patiala",
      "Prof. Shruti Jain, Jaypee University of Information Technology, Waknaghat, Solan, H.P.",
      "Prof. Vineet Mehan, NIMS University, Jaipur, Rajasthan, India",
      "Prof. K S Sandha, Thapar University, Patiala",
      "Prof. Vibhav Kumar Sachan, KIET, Ghaziabad",      
      "Prof. Ankita Aggarwal, SET, CGC University, Mohali",
      "Prof. Saurabh, SET, CGC University, Mohali",
    ]
  },
  
  {
    title: "PUBLICATION CHAIR",
    items: [
   
      "Prof. Ashwani K Sharma, SET, CGC University, Mohali",
      "Prof. Rini Saxena, SET, CGC University, Mohali",
    ]
  },
  {
    title: "PUBLICITY CHAIR",
    items: [
      "Prof. Sonia Bhukra, SET, CGC University, Mohali",
      "Prof. Bhawna, SET, CGC University, Mohali",
    ]
  },
  {
    title: "FINANCE CHAIR",
    items: [
      "Prof. Ishu Sharma, SET, CGC University, Mohali",
      "Prof. Tanya Garg, SET, CGC University, Mohali",
    ]
  },
  {
    title: "REGISTRATION CHAIR",
    items: [
      "Prof. Rohini Sharma, SET, CGC University, Mohali",
      "Prof. Sumanpreet Kaur, SET, CGC University, Mohali",
    ]
  }
  
];

const FacultyTable = () => {
  return (
    <>
    <div className="container mx-auto p-4 pt-20 sm:pt-4">
      <h1 className="text-2xl sm:text-3xl font-bold mb-4 text-center uppercase">Organising Committee</h1>
      {sections.map((section, index) => (
        <div >
          <div className="flex flex-wrap mt-6 w-full relative flex-col flex-auto">
            <h1 className="mb-5 sm:text-[1.75rem] font-bold text-dark uppercase">
              {section.title}
            </h1>
          </div>
          <div className="flex w-full text-lg sm:text-2xl">
            <ul className="list-disc pl-5">
              {section.items.map((item, idx) => (
                <li className="mb-4">
                  {item}
                </li>
              ))}
            </ul>
          </div>
        </div>
      ))}
    </div>
    <Steering />
    <Technical />
    <Advisory />
    <Finance/>
    <Publication/>
    <Publicity/>
    <Hospitality/>
    <Accommodation/>
    <Transportation/>
    <StudentTeam/>
    
    
    </>
  );
  
};

export default FacultyTable;